(function() {
    //Check if user is running IE 11 or older
    if (window.navigator.userAgent.match(/MSIE|Trident/)) {
        window.location = "/browser-support.html";
    }
}())